import { Component, OnInit } from '@angular/core';
import { ActivatedRoute, Params } from '@angular/router';
import Swal from 'sweetalert2';
import { Constants } from '../shared/Helpers/constants';
import { SharedService } from '../shared/shared.service';
import { WorkflowService } from '../_services';

@Component({
  selector: 'user-prompt-submit',
  templateUrl: './user-prompt-submit.component.html'
})

export class UserPromptSubmitComponent implements OnInit {
  public logoPath: any;
  public requestId: string;
  public workflowRunId: any;
  public elementId: any;
  public responseOptionType: any;
  public radioButtonsResponse: Array<any> = [];
  public userPromptAnswerToSend: any;
  public responseMessage: string;
  public optionsList: Array<any> = [];
  public characterLimit: number;
  public responseSubmitted: boolean = false;
  public ulsterOrganisationId: boolean = false; 
  public lululemonOrganisationId: boolean = false;
  public responderEmail: string;


  constructor(
    private route: ActivatedRoute,
    private workflowService: WorkflowService,
    public sharedService: SharedService,
    ) {
  }

  ngOnInit() {
    this.route.params.subscribe((param: Params) => {
      this.workflowRunId = param.workflowRunId;
      this.elementId = param.workflowElementId;
      const requestIdParam = param.requestId;
      this.requestId = requestIdParam.substring(0, requestIdParam.length - 36) + ';' + param.requestId.substring(requestIdParam.length - 36, param.requestId.length)
    });

    this.route.queryParams.subscribe((params: Params) => {
      this.responderEmail = atob(Array.isArray(params.email) ? params.email[0] : params.email);
      this.responseOptionType = params.type;
      this.radioButtonsResponse = params.option;
      this.responseMessage = params.response;
      this.characterLimit = params.limit;
    });

    if (this.radioButtonsResponse != undefined) {
      let responseOptions: Array<any> = [];

      if (Array.isArray(this.radioButtonsResponse) == false) {
        responseOptions.push(this.radioButtonsResponse)
      } else {
        responseOptions= this.radioButtonsResponse;
      }

      responseOptions.forEach(option => {
        option = option.replace(/\+/gi, ' ');
        this.optionsList.push(option);
      })
    }

    this.getOrganisationData();
  }

  ngDoCheck() {
    if (this.sharedService.loadedOrganisationByUrl.value) {
      if (this.sharedService.loginCustomisation.value != undefined && this.sharedService.loginCustomisation.value != null) {
        if (this.sharedService.LogoImage.value != null) {
         this.logoPath = null;
          this.logoPath = this.sharedService.LogoImage.value;
        } else {
          this.logoPath = this.ulsterOrganisationId ? Constants.ulsterLogoPath : this.lululemonOrganisationId ? Constants.lululemonLogoPath : Constants.logoPath;
        }
      } else {
        this.logoPath = this.ulsterOrganisationId ? Constants.ulsterLogoPath : this.lululemonOrganisationId ? Constants.lululemonLogoPath : Constants.logoPath;
      }
    } else {
      this.logoPath = this.ulsterOrganisationId ? Constants.ulsterLogoPath : this.lululemonOrganisationId ? Constants.lululemonLogoPath : Constants.logoPath;
    }
  }

  private getOrganisationData() {
    this.workflowService.getWorkflowByWorkflowRunId(this.workflowRunId).subscribe({
      next: (res) => {
        this.ulsterOrganisationId = res.organisationId == Constants.ulsterOrganisationId ? true : false;
        this.lululemonOrganisationId = res.organisationId == Constants.lululemonOrganisationId ? true : false;
        this.sharedService.changeCurrentOrganisationId(res.organisationId);
      },
      error: (err) => {
      }
    });
  }

  public submitResponse() {
    this.responseSubmitted = true;
    this.workflowService.getUserPromptResponse(this.requestId, this.workflowRunId, true, this.elementId).subscribe((res: any) => {
      if (res.response == "Submitted by another user") {
        Swal.fire({
          title: 'A response has already been submitted by another user. Your response was not submitted.',
          icon: 'warning',
          showConfirmButton: false,
          allowOutsideClick: false,
          allowEscapeKey: false,
          allowEnterKey: false
        })
      }

      else if (res.response == "Time limit execeeded") {
        Swal.fire({
          title: 'The response was not submitted within the time frame set. Your response was not submitted.',
          icon: 'warning',
          showConfirmButton: false,
          allowOutsideClick: false,
          allowEscapeKey: false,
          allowEnterKey: false
        })
      }
      else {
        this.workflowService.saveUserPromptResponse(this.userPromptAnswerToSend, this.requestId, this.workflowRunId, this.elementId, this.responderEmail).subscribe({
          next: () => {
            Swal.fire({
              title: 'Your response has been submitted. Thank you.',
              icon: 'success',
              showConfirmButton: false,
              allowOutsideClick: false,
              allowEscapeKey: false,
              allowEnterKey: false
            })
          },
          error: () => {
            Swal.fire({
              title: 'It has not been possible to submit your response at this time. For further investigation please contact your Able+ administrator quoting ID ' + this.requestId + '.',
              icon: 'warning',
              showConfirmButton: false,
              allowOutsideClick: false,
              allowEscapeKey: false,
              allowEnterKey: false
            })
          }
        });
      }
    });
  }
}
